'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { SPACING } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import Spacing from 'ContentComponents/cmv2/fields/Spacing';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class SpacingContentOptions extends Component {
  constructor(props) {
    super(props);
    this.onDefaultChange = this.onDefaultChange.bind(this);
  }

  onDefaultChange(value) {
    this.props.editField({
      [DEFAULT]: value
    });
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`defaultLabels.${SPACING}`)
      }),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: Spacing,
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT],
        readOnly: readOnly
      })
    });
  }

}

SpacingContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};
export default SpacingContentOptions;